import { Component } from 'solid-js'
import GenerateImageOptionButton from './GenerateImageOptionButton'

const GenerateImageAccessoriesOptions: Component<{
  updatePrompt: (value: string, replacePrompt: boolean) => void
}> = (props) => {
  return (
    <div class="flex flex-row flex-wrap gap-4">
      <GenerateImageOptionButton
        title="Necklace"
        value="wearing a necklace"
        onClick={props.updatePrompt}
      />
      <GenerateImageOptionButton
        title="Earrings"
        value="wearing earrings"
        onClick={props.updatePrompt}
      />
      <GenerateImageOptionButton
        title="Tattoos"
        value="tattoos on the body"
        onClick={props.updatePrompt}
      />
      <GenerateImageOptionButton
        title="Glasses"
        value=" wearing stylish glasses"
        onClick={props.updatePrompt}
      />
      <GenerateImageOptionButton
        title="Candles"
        value="a room lit with aromatic candles"
        onClick={props.updatePrompt}
      />
      <GenerateImageOptionButton
        title="Scarf"
        value="wearing a colorful scarf"
        onClick={props.updatePrompt}
      />
      <GenerateImageOptionButton
        title="Baseball cap"
        value="wearing a baseball cap outdoors"
        onClick={props.updatePrompt}
      />
    </div>
  )
}

export default GenerateImageAccessoriesOptions
